import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from './dropdown.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { DropdownDirective } from './dropdown.directive';
import { MultiStepDropdownComponent } from './multi-step-dropdown/multi-step-dropdown.component';
import { SearchBoxModule } from '../search-box/search-box.module';
import { IconModule } from '../icon/icon-module';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  declarations: [DropdownComponent, DropdownDirective, MultiStepDropdownComponent],
  imports: [CommonModule, PipesModule, SearchBoxModule, IconModule, SpinnerModule],
  exports: [DropdownComponent, MultiStepDropdownComponent],
  providers: [DropdownDirective],
})
export class DropdownModule {}
